var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { defineComponent, inject, ref } from 'vue';
import PropTypes from '../_util/vue-types';
import VcCheckbox from '../vc-checkbox';
import classNames from '../_util/classNames';
import useConfigInject from '../_util/hooks/useConfigInject';
import { useInjectFormItemContext } from '../form/FormItemContext';
export const radioProps = {
    prefixCls: PropTypes.string,
    checked: PropTypes.looseBool,
    disabled: PropTypes.looseBool,
    isGroup: PropTypes.looseBool,
    value: PropTypes.any,
    name: PropTypes.string,
    id: PropTypes.string,
    autofocus: PropTypes.looseBool,
    type: PropTypes.string.def('radio'),
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
};
export default defineComponent({
    name: 'ARadio',
    props: radioProps,
    emits: ['update:checked', 'update:value', 'change', 'blur', 'focus'],
    setup(props, { emit, expose, slots }) {
        const formItemContext = useInjectFormItemContext();
        const vcCheckbox = ref();
        const radioGroupContext = inject('radioGroupContext', undefined);
        const { prefixCls, direction } = useConfigInject('radio', props);
        const focus = () => {
            vcCheckbox.value.focus();
        };
        const blur = () => {
            vcCheckbox.value.blur();
        };
        expose({ focus, blur });
        const handleChange = (event) => {
            const targetChecked = event.target.checked;
            emit('update:checked', targetChecked);
            emit('update:value', targetChecked);
            emit('change', event);
            formItemContext.onFieldChange();
        };
        const onChange = (e) => {
            emit('change', e);
            if (radioGroupContext && radioGroupContext.onRadioChange) {
                radioGroupContext.onRadioChange(e);
            }
        };
        return () => {
            const radioGroup = radioGroupContext;
            const { prefixCls: customizePrefixCls, id = formItemContext.id.value } = props, restProps = __rest(props, ["prefixCls", "id"]);
            const rProps = Object.assign({ prefixCls: prefixCls.value, id }, restProps);
            if (radioGroup) {
                rProps.name = radioGroup.props.name;
                rProps.onChange = onChange;
                rProps.checked = props.value === radioGroup.stateValue.value;
                rProps.disabled = props.disabled || radioGroup.props.disabled;
            }
            else {
                rProps.onChange = handleChange;
            }
            const wrapperClassString = classNames({
                [`${prefixCls.value}-wrapper`]: true,
                [`${prefixCls.value}-wrapper-checked`]: rProps.checked,
                [`${prefixCls.value}-wrapper-disabled`]: rProps.disabled,
                [`${prefixCls.value}-wrapper-rtl`]: direction.value === 'rtl',
            });
            return (<label class={wrapperClassString}>
          <VcCheckbox {...rProps} ref={vcCheckbox}/>
          {slots.default && <span>{slots.default()}</span>}
        </label>);
        };
    },
});
